import {
  LO_NAME,
  LO_NMLS,
  PHONE_NUMBER,
  PHONE_TEL,
  LO_SITE,
  LO_SITE_LABEL,
  PRMG_NMLS,
  PRMG_ADDRESS,
  PRMG_LOGO,
} from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A2F6B] text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="bg-white rounded-md px-4 py-3 inline-block">
              <img
                src={PRMG_LOGO}
                alt="PRMG — Paramount Residential Mortgage Group"
                className="h-12 md:h-14 w-auto"
              />
            </div>
            <p className="text-white/70 text-sm mt-4 leading-relaxed max-w-sm">
              Paramount Residential Mortgage Group, Inc. NMLS #{PRMG_NMLS}.
              An Equal Housing Opportunity lender.
            </p>
            <p className="text-white/60 text-xs mt-4 leading-relaxed max-w-sm">{PRMG_ADDRESS}</p>
          </div>

          {/* Loan officer */}
          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.22em] text-[#F26A21] font-semibold mb-3">
              Loan Officer
            </p>
            <p className="font-display font-bold text-white text-xl">{LO_NAME}</p>
            <p className="text-white/70 text-sm mt-1">NMLS# {LO_NMLS}</p>
            <a
              href={PHONE_TEL}
              data-testid="footer-phone-link"
              className="block mt-3 text-white hover:text-[#F26A21] transition-colors tabular-nums font-semibold"
            >
              {PHONE_NUMBER}
            </a>
            <a
              href={LO_SITE}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-site-link"
              className="block mt-1 text-white/80 hover:text-[#F26A21] transition-colors text-sm break-all"
            >
              {LO_SITE_LABEL}
            </a>
          </div>

          {/* Quick links */}
          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.22em] text-[#F26A21] font-semibold mb-3">
              Explore
            </p>
            <ul className="space-y-2 text-sm">
              <li><a href="#uses" className="text-white/85 hover:text-[#F26A21] transition-colors">HELOC Uses</a></li>
              <li><a href="#officer" className="text-white/85 hover:text-[#F26A21] transition-colors">Meet Randy</a></li>
              <li><a href="#faq" className="text-white/85 hover:text-[#F26A21] transition-colors">FAQ</a></li>
              <li><a href="#contact" className="text-white/85 hover:text-[#F26A21] transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        {/* Compliance / Legal Links — full width */}
        <ul data-testid="footer-compliance-links" className="mt-10 pt-8 border-t border-white/15 flex flex-wrap gap-x-8 gap-y-2 text-[14.5px] leading-relaxed">
          <li>
            <a
              href="https://url.us.m.mimecastprotect.com/s/ExrDCjR50vCnXKnpRfWfGcmjhV0?domain=prmg.net"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-licensing-link"
              className="text-white hover:text-[#F26A21] transition-colors"
            >
              Licensing
            </a>
          </li>
          <li>
            <a
              href="https://url.us.m.mimecastprotect.com/s/NxizCkRBrwCOj8Om5FVhmcGG-Mt?domain=prmg.net"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-terms-link"
              className="text-white hover:text-[#F26A21] transition-colors"
            >
              Terms of Use
            </a>
          </li>
          <li>
            <a
              href="https://www.prmg.net/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-privacy-link"
              className="text-white hover:text-[#F26A21] transition-colors"
            >
              Privacy Policy
            </a>
          </li>
        </ul>

        {/* Legal */}
        <div className="mt-12 pt-8 border-t border-white/15">
          <p className="text-[11px] leading-relaxed text-white/60">
            &copy; 2026 Paramount Residential Mortgage Group, Inc. (&ldquo;PRMG&rdquo;) NMLS #{PRMG_NMLS}.
            (www.nmlsconsumeraccess.org). {PRMG_ADDRESS}. Equal Housing Opportunity.
            Mortgage Banker License #910387. Licensed by the Department of Financial Protection and Innovation under the California Residential Mortgage Lending Act.
            Massachusetts Broker and Lender Licenses MC{PRMG_NMLS}. Licensed by the N.J. Department of Banking and Insurance. Rhode Island Licensed Lender. Not a commitment to lend.
            All applications are subject to underwriting guidelines and product/program availability, creditworthiness, loan amount, property type, and other factors. Products and services may not be available in all areas and are subject to change without notice.
          </p>
          <p className="text-[11px] mt-3 text-white/50">
            * Timing may vary based on borrower qualifications and documentation requirements.{" "}
            ** A HELOC may allow eligible homeowners to access equity without refinancing their existing first mortgage.
          </p>
        </div>
      </div>
    </footer>
  );
}
